import { selectDesktopSettings } from '@store/desktop/desktop.selector';
import { State } from '@store/reducer';
import { logout } from '@store/user/user.actions';
import { getUser } from '@store/user/user.selector';
import { ConnectedProps, connect } from 'react-redux';

export type AboutModalReduxProps = ConnectedProps<typeof aboutModalConnector>;

const mapStateToProps = (state: State) => ({
  settings: selectDesktopSettings(state),
  user: getUser(state),
});

export const aboutModalConnector = connect(mapStateToProps, { logout });
